import React from 'react'
import styles from './ProtocolInfographic.module.css'

export default function AdherenceRingLight({ value }) {
  const safeValue = typeof value === 'number' ? value : 0
  const r = 22
  const c = 2 * Math.PI * r
  const offset = c - (safeValue / 100) * c
  return (
    <div className={styles.ringWrapperLight} title="Current adherence">
      <svg className={styles.ringSvgLight} viewBox="0 0 56 56">
        <circle className={styles.ringCircleOuterLight} cx="28" cy="28" r={r} />
        <circle
          className={styles.ringCircleInnerLight}
          cx="28" cy="28" r={r}
          strokeDashoffset={offset}
          strokeDasharray={c}
        />
      </svg>
      <div className={styles.ringLabelLight}>
        <span className={styles.ringValueLight}>{safeValue}%</span>
        <span className={styles.ringTextLight}>adhere</span>
      </div>
    </div>
  )
}
